import { useQuery } from '@tanstack/react-query';
import { worldMonitorApi, type WorldMonitorLiveResponse } from '../api/worldMonitor';

/**
 * @param options.pollInterval — Override the default 15s poll cadence.
 *   Pass a slower value (e.g. 30_000) when the live feed is background-only,
 *   or `false` to disable polling entirely.
 */
export function useWorldMonitorLive(options?: { pollInterval?: number | false }) {
  const query = useQuery<WorldMonitorLiveResponse>({
    queryKey: ['world-monitor-live'],
    queryFn: () => worldMonitorApi.getLive(),
    staleTime: 10_000,
    refetchInterval: options?.pollInterval ?? 15_000,
    placeholderData: (prev) => prev,
  });

  return {
    data:
      query.data ?? {
        updated_at: new Date(0).toISOString(),
        summary: {
          updated_at: new Date(0).toISOString(),
          tension_index: 0,
          tension_level: 'unavailable',
          chaos_index: 0,
          active_missions: 0,
          active_agents: 0,
          active_signals: 0,
          critical_signals: 0,
          convergence_cells: 0,
        },
        signal_accounting: { total_live: 0, visible: 0, cap: 120, is_capped: false },
        category_counts: {},
        severity_counts: {},
        source_counts: {},
        signals: [],
        convergence_cells: [],
        missions: [],
        intel: [],
        live_feed: [],
      },
    isLoading: query.isLoading,
    error: query.error,
  };
}
